// https://manage.auth0.com/dashboard/us/aime-leon-dore/applications/h4ySMDTBwysTyLqHr911CLdCXRMEtqer/settings
export default {
  domain: "aime-leon-dore.us.auth0.com",
  clientId: "h4ySMDTBwysTyLqHr911CLdCXRMEtqer"
}
